import type { RootState } from "@src/store/rootState";
import * as basicMod from "@src/store/slices/experienceBuilder/basicMod/selectors/getVariationDraft";
import * as component from "@src/store/slices/experienceBuilder/component/selectors/getVariationDraft";

export function getVariationDraft(state: RootState) {
  return (
    basicMod.getVariationDraft(state) ?? component.getVariationDraft(state)
  );
}
